<template>
    <div class="ecommerce_product_select_category" >
        <a href="javascript:void(0);" class="btn btn-none-radius" @click="onChangeCategory('all')" :class="{'btn-default': currentCategory != 'all' , 'btn-primary' : currentCategory == 'all'}" style="margin-right:5px">All<template v-if="stat.all > 0"> ({{stat.all}})</template></a>
        <!-- <a href="javascript:void(0);" class="btn btn-none-radius" @click="onChangeCategory('soldout')" :class="{'btn-default': currentCategory != 'soldout' , 'btn-primary' : currentCategory == 'soldout'}" style="margin-right:5px">Sold Out<template v-if="stat.soldout > 0"> ({{stat.soldout}})</template></a>
        <a href="javascript:void(0);" class="btn btn-none-radius" @click="onChangeCategory('sales')" :class="{'btn-default': currentCategory != 'sales' , 'btn-primary' : currentCategory == 'sales'}" style="margin-right:5px">Sales<template v-if="stat.sales > 0"> ({{stat.sales}})</template></a> -->
		<a href="javascript:void(0);" class="btn btn-none-radius" v-if="categorylist" @click="onChangeCategory(category.id)" :class="{'btn-default': currentCategory != category.id , 'btn-primary' : currentCategory == category.id}" v-for="(category,index) in categorylist" :key="'category_'+index" style="margin-right:5px">{{category.name}}</a>
	</div>
</template>

<script>
    export default {
        props : {
            'value': [String,Number],
            'categories': Array,
            'stat': {
                default: {
                    all: 0,
                    soldout: 0,
                    sales: 0
                },
                type: Object
            }
        },
        data : function(){
            return {
                categorylist: this.categories,
                currentCategory : this.value
            }
        },
        methods: {
            onChangeCategory : function(index){
                let vm = this
                vm.currentCategory = index
                vm.$emit('input',vm.currentCategory)
            }
        },
        watch : {
            value: function(){
                this.currentCategory = this.value
            },
            categories: function(){
                this.categorylist = this.categories
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/template/event/FilterCategory.vue